import {connect} from 'react-redux';
import {
  agendaSelector,
  agendaLoadingSelector
} from '../../../reducers';
import Agenda from './component';

const mapStateToProps = (state) => {
  return {
    agenda: agendaSelector(state) || {},
    loading: agendaLoadingSelector(state) ? true : false
  };
};

export default connect(mapStateToProps)(Agenda);



// WEBPACK FOOTER //
// ./src/component/pages/Agenda/index.js